module.exports = __webpack_public_path__ + "media/images/new/cta-loop-1-1e343b50351f9651dbc2e9ac4c38cbf5.png";